import {NotificationInfo} from '@/api/dto/notification';
import {EncounterType} from "@/api/dto/client-profile";
import {dateRange, groupedValues, nonGroupedValues} from "@common/FilterComponent";
import {FormCodeBinding, RosterFormCodeBinding} from "@/api/dto/forms";
import {FilterView} from "@/api/dto/filters";
import {ConnectContactChannel} from "@/api/dto/connect";

export enum MixpanelEventType {
    BIH_USER_LOGGED_IN = "BIH - User Logged in",
    BIH_ADMIN_PAGE_VIEWED = "BIH - Admin Page Viewed",
    BIH_SSO_LAUNCHED = "BIH - SSO Launched",
    BIH_NOTIFICATIONS_UPDATED = "BIH - Notifications Updated",
    BIH_NOTIFICATIONS_FOR_ALL_CLIENTS = "BIH - Notifications for All Clients",
    BIH_USER_INVITED = "BIH - User Invited",
    BIH_FORM_UPLOADED = "BIH - Form Upload Completed",
    BIH_FORM_EXPORTED = "BIH - Form Exported",
    BIH_FORM_DELETED = "BIH - Form Deleted",
    BIH_FORM_SAVED = "BIH - Form Saved",
    BIH_FORM_SUBMITTED = "BIH - Form Submitted",
    BIH_CLIENT_LIST_VIEWED = "BIH - Client List Viewed",
    BIH_VIEW_FILTERED= "BIH - View Filtered",
    BIH_SAVED_FILTER_CREATED = "BIH - Saved Filter Created", //
    BIH_SAVED_FILTER_EDITED = "BIH - Saved Filter Edited",
    BIH_SAVED_FILTER_USED = "BIH - Saved Filter Used",
    BIH_SAVED_FILTER_PINNED = "BIH - Saved Filter Pinned",
    BIH_PINNED_FILTER_APPLIED = "BIH - Pinned Filter Applied",
    BIH_TABLE_SEARCHED = "BIH - Table Searched",
    BIH_TABLE_SORTED = "BIH - Table Sorted",
    BIH_FORM_UPLOAD_MODAL_OPENED = "BIH - Form Upload Modal Opened",
    BIH_CLIENT_PROFILE_VIEWED = "BIH - Client Profile Viewed",
    BIH_SENT_IN_APP_MESSAGE = "BIH - Sent In-App Message",
    BIH_ASSIGNED_CLIENT_TO_SELF = "BIH - Assigned Client to Self",
    BIH_ASSIGNED_TASK_TO_SELF = "BIH - Assigned Task to Self",
    BIH_ASSIGN_TASK_TO_HUMAN = "BIH - Assign Task to Human",
    BIH_MANUAL_ADMIT_CREATED = "BIH - Manual Admit Created",
    BIH_MANUAL_DISCHARGE_CREATED = "BIH - Manual Discharge Created",
    BIH_ACCESSED_PDMP_REPORT = "BIH - Accessed PDMP Report",
    BIH_TASKS_PAGE_VIEWED = "BIH - Tasks Page Viewed",
    BIH_TASK_VIEWED = "BIH - Task Viewed",
    BIH_TASK_CLOSED = "BIH - Task Closed",
    BIH_UNASSIGN_AI_FROM_TASK = "BIH - Unassign AI from Task",
    BIH_ASSIGN_TASK_TO_AI = "BIH - Assign Task to AI",
    BIH_TASK_DUE_DATE_CHANGED = "BIH - Due Date Changed in Task",
    BIH_PRIORITY_CHANGED_IN_TASK = "BIH - Priority Changed in Task",
    BIH_MESSAGE_THREAD_STARTED_IN_TASK = "BIH - Message Thread Started in Task",
    BIH_TASK_STEP_FORM_UPDATED = "BIH - Task Step Form Updated",
    BIH_DSAMH_CRF_ADMISSION_FORM_EXPORTED = "BIH - DSAMH CRF Admission Form Exported",
    BIH_DSAMH_CRF_DISCHARGE_FORM_EXPORTED = "BIH - DSAMH CRF Discharge Form Exported",
    BIH_INTAKE_FORM_EXPORTED = "BIH - Intake Form Exported",
    BIH_FORM_TEMPLATE_UPDATED = "BIH - Form Template Updated",
    BIH_CLIENT_IDENTIFIER_ADDED = "BIH - Client Identifier Added",
    BIH_CLIENT_IDENTIFIER_UPDATED = "BIH - Client Identifier Updated",
    BIH_DISCHARGE_INSTRUCTIONS_UPLOADED_IN_FORMS = "BIH - Discharge Instructions Uploaded in Forms",
    BIH_DISCHARGE_INSTRUCTIONS_UPLOADED_IN_MESSAGES = "BIH - Discharge Instructions Uploaded in Messages",
    BIH_CARE_JOURNEY_ESCALATED = "BIH - Care Journey Escalated to Care Team",
    BIH_STEP_SAVED = "BIH - Step Saved",
    BIH_STEP_RESUBMITTED = "BIH - Step Re-submitted",
    BIH_ATTESTATION_COMPLETED = "BIH - Attestation Completed",
    BIH_APPOINTMENT_SCHEDULED = "BIH - Appointment Scheduled",
    BIH_PREVIEW_CARE_NOTE_SELECTED = "BIH - Preview Care Note Selected",
    BIH_CARE_NOTE_DOWNLOADED = "BIH - Care Note Downloaded",
    BIH_TASK_MESSAGE_SENT = "BIH - Task Message Sent",
    BIH_ADDITIONAL_DETAILS_FORM_OPENED = "BIH - Additional Details Form Opened",
    BIH_AWS_COMMUNICATIONS_OPENED = "BIH - AWS Communications Opened",
    BIH_AWS_COMMUNICATION_COMPLETED = "BIH - AWS Communication Completed",
}

export enum AppointmentType {
    PCP = "pcp",
    THERAPY = "therapy",
    MEDICATION_MANAGEMENT = "medication_management",
    ADHD_TESTING = "adhd_testing",
    NEUROPSYCHOLOGY_TESTING = "neuropsychology_testing",
    SPRAVATO_TMS = "spravato_tms",
}

export enum AppointmentSchedulingMode {
    AI = "AI",
    HITL = "HITL",
}

export enum ViaType {
    EMAIL = "Email",
    NOTIFICATIONS = "Notifications",
    CLIENT_PROFILE = "Client Profile",
    CLIENT_LIST = "Client List",
    ADMIN = "Admin",
    USER_PROFILE = "User Profile",
    TASKS = "Tasks",
    FORM_TEMPLATES = "Form Templates",
}

export enum AdminPageTab {
    USERS = "Users",
    GROUPS = "Groups",
    ORGANIZATIONS = "Organizations",
}

export enum ClientPageTab {
    SUMMARY = "Summary",
    FORMS = "Forms",
    PDMP = "PDMP",
}

export enum SSOLaunchMethod {
    CREATE_BUTTON = "Create Button",
    APPLICATION_MENU = "Application Menu",
}

export enum SSOApplication {
    OPENBEDS_REFERRALS = "OpenBeds Referrals",
    OPENBEDS_CRISIS = "OpenBeds Crisis",
    FINDHELP = "FindHelp",
    ROUND_TRIP = "RoundTrip",
    TREATMENT_CONNECTION = "Treatment Connection",
}

export enum TableName{
    CLIENT_LIST = "Clients",
    USERS = "Users",
    GROUPS = "Groups",
    ORGANIZATIONS = "Organizations",
    FORMS = "Forms",
    CLIENT_PROFILE = "Client Timeline",
    TASKS = "Tasks",
}

export enum FormStatus {
    COMPLETED = "Completed",
}

export enum FormOrigin {
    UPLOADED = "Uploaded",
}

export enum FormExportMethod {
    PRINT = "Print",
    DOWNLOAD = "Download",
}

export enum TabName{
    CLIENT_LIST = "Client List",
    USERS = "Users",
    GROUPS = "Groups",
    ORGANIZATIONS = "Organizations",
    FORMS = "Forms",
    CLIENT_PROFILE = "Client Timeline"
}

export interface MixpanelEvent{
    eventName: MixpanelEventType;
    viewPortWidth: number;
    viewPortHeight: number;
    $os: string;
    device: string;
    currentApplicationLocation: string;
    pageUrl: string;
    via: Nullable<ViaType>;
}

export interface MixpanelLoginEvent extends MixpanelEvent {
    isSso: boolean;
    ssoConnection: Nullable<string>;
}

export interface MixpanelAdminPageEvent extends MixpanelEvent {
    tabViewed: AdminPageTab;
    adminAccess: string
}

export interface MixpanelSSOLaunchEvent extends MixpanelEvent {
    applicationName: SSOApplication,
    launchMethod: SSOLaunchMethod;
}

export interface MixpanelNotificationsUpdatedEvent extends MixpanelEvent {
    notificationType: NotificationInfo['profileLabelText'];
    notificationEnabled: boolean;
    eventsEnabled: string[];
    notificationSchedule: string;
    deliveryMethod: string[];
}

export interface MixpanelNotificationsForAllClientsEvent extends MixpanelEvent {
    notificationsForAllClients: boolean;
}

// Sort Events
interface MixpanelSortEventBase extends MixpanelEvent {
    tableName: TableName,
    sortCriteria?: string
}

interface MixpanelSortEventWithGroup extends MixpanelSortEventBase, MixpanelCurrentGroupDetails {}

export type MixpanelSortEvent = MixpanelSortEventBase | MixpanelSortEventWithGroup;

export interface MixpanelUserInvitedEvent extends MixpanelEvent {
    sender: string | undefined,
    invitee: string | undefined,
    inviteeGroupIds: number[]
}

export interface MixpanelCurrentGroupDetails {
    currentGroupName: string,
    currentStateName: string,
    currentGroupId: number,
    currentGroupType: string,
    currentOrganizationName: string,
    currentOrganizationId: string,
}

// Form Events
interface MixpanelFormEventBase extends MixpanelEvent {
    clientId: string,
    formId?: number,
    formName: string,
    formType: string,
    fileSize?: string,
    exportMethod?: FormExportMethod,

    // Currently, has only one property, but can be extended in the future.
    formStatus?: FormStatus,
    formOrigin?: FormOrigin,
    formUploadTime?: number,
}

interface MixpanelFormEventWithGroup extends MixpanelFormEventBase, MixpanelCurrentGroupDetails {}

export type MixpanelFormEvent = MixpanelFormEventBase | MixpanelFormEventWithGroup;

// Form Submit Events
interface MixpanelFormSubmitEventBase extends MixpanelEvent {
    clientId: string;
    codeBinding?: FormCodeBinding | RosterFormCodeBinding;
}

interface MixpanelFormSubmitEventWithGroup extends MixpanelFormSubmitEventBase, MixpanelCurrentGroupDetails {}

export type MixpanelFormSubmitEvent = MixpanelFormSubmitEventBase | MixpanelFormSubmitEventWithGroup;

// Client List Events
type MixpanelClientListEventBase = MixpanelEvent;

interface MixpanelClientListEventWithGroup extends MixpanelEvent, MixpanelCurrentGroupDetails {}

export type MixpanelClientListEvent = MixpanelClientListEventBase | MixpanelClientListEventWithGroup;

// Filter Events
type FilterCriteria = string[] | {
    [key: string]: string | string[] | boolean | number | groupedValues[] | nonGroupedValues | dateRange | null;
};

interface MixpanelViewFilteredEventBase extends MixpanelEvent {
    viewName: string;
    filterCriteria: FilterCriteria;
}

interface MixpanelViewFilteredEventWithGroup extends MixpanelViewFilteredEventBase, MixpanelCurrentGroupDetails {}

export type MixpanelViewFilteredEvent = MixpanelViewFilteredEventBase | MixpanelViewFilteredEventWithGroup;


interface MixpanelSavedFilterEventBase extends MixpanelEvent {
    filterId: number;
    filterName: string;
    filterOwnerId: string;
    filterCriteriaCount: number;
    filterFieldsUsed: string[];
    filterView: FilterView;
    fieldsAdded: string[];
    fieldsRemoved: string[];
}

interface MixpanelSavedFilterEventWithGroup extends MixpanelSavedFilterEventBase, MixpanelCurrentGroupDetails {}

export type MixpanelFilterEvent = MixpanelSavedFilterEventBase | MixpanelSavedFilterEventWithGroup;

// Table Search Events
interface MixpanelTableSearchedEventBase extends MixpanelEvent {
    tableName: string;
    searchBy?: string;
}

interface MixpanelTableSearchedEventWithGroup extends MixpanelTableSearchedEventBase, MixpanelCurrentGroupDetails {}

export type MixpanelTableSearchedEvent = MixpanelTableSearchedEventBase | MixpanelTableSearchedEventWithGroup;

// Client Profile Events
interface MixpanelClientProfilePageViewedEventBase extends MixpanelEvent {
    clientId: string;
    tabViewed: ClientPageTab;
    encounterIds: {
        [key in EncounterType]?: string[];
    };
}

interface MixpanelClientProfilePageViewedEventWithGroup
    extends MixpanelClientProfilePageViewedEventBase, MixpanelCurrentGroupDetails {}

export type MixpanelClientProfilePageViewedEvent =
    MixpanelClientProfilePageViewedEventBase | MixpanelClientProfilePageViewedEventWithGroup;

// Form Upload Events
interface MixpanelFormUploadBase extends MixpanelEvent {
    clientId: string
}

interface MixpanelFormUploadWithGroup extends MixpanelFormUploadBase, MixpanelCurrentGroupDetails {}

export type MixpanelFormUpload = MixpanelFormUploadBase | MixpanelFormUploadWithGroup;

// Task Events - Always have group details
export interface MixpanelTaskEvent extends MixpanelEvent, MixpanelCurrentGroupDetails {
    eventType: string;
    careJourneyName: string;
}

// Step Events - a task event carrying which care-journey step it applies to
export interface MixpanelStepEvent extends MixpanelTaskEvent {
    stepName: string;
}

// Appointment Scheduled - a task event carrying the appointment type and who scheduled it
export interface MixpanelAppointmentScheduledEvent extends MixpanelTaskEvent {
    appointmentType: AppointmentType;
    appointmentSchedulingMode: AppointmentSchedulingMode;
}

// Who made the assignment is the acting user, already attached server-side as userEmail.
export interface MixpanelTaskAssignmentEvent extends MixpanelTaskEvent {
    assignedTo: string;
}

export interface MixpanelTaskClosedEvent extends MixpanelTaskEvent {
    // The reason value sent to the close API, not the display label.
    closeReason: string;
}

// Roster-bound form drawer opened - carries the client whose form was opened
export interface MixpanelFormOpenedEvent extends MixpanelEvent, MixpanelCurrentGroupDetails {
    clientId: string;
    codeBinding: RosterFormCodeBinding;
}

// AWS Communications - roster-scoped, so no care-journey context
export interface MixpanelAwsCommunicationEvent extends MixpanelEvent, MixpanelCurrentGroupDetails {
    channel: ConnectContactChannel;
}

export interface MixpanelFormTemplateUpdatedEvent extends MixpanelEvent{
    formTemplateName: string;
}

export interface MixpanelPrintEvent extends MixpanelEvent{
    formName: string;
}

export interface MixpanelClientIdentifierUpdated extends MixpanelEvent{
    patientId: string;
}
